import { render, staticRenderFns } from "./SetupSection.vue?vue&type=template&id=64f6df6e&scoped=true"
import script from "./SetupSection.vue?vue&type=script&lang=js"
export * from "./SetupSection.vue?vue&type=script&lang=js"
import style0 from "./SetupSection.vue?vue&type=style&index=0&id=64f6df6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6df6e",
  null
  
)

export default component.exports